export interface SearchItem {
  type: string;
  context?: any;
  displayValue?: string;
}

export interface GroupedSearchResults {
  [key: string]: SearchItem[];
}

export enum SearchExpandFromDirection {
  LEFT,
  RIGHT,
}
